module.exports = __webpack_public_path__ + "static/media/Mobile_a_tecnologia_do_futuro-13.f977a5a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/A_Tecnoliga_do_futuro/Mobile_a_tecnologia_do_futuro-13.png
// module id = 106
// module chunks = 0